import type { SVGProps } from 'react';

interface CircleDollarSellProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

export default function CircleDollarSell({
  size = 20,
  color = 'currentColor',
  className,
  ...props
}: CircleDollarSellProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      {...props}
    >
      <path
        d="M7.91699 11.4585C7.91699 12.2669 8.542 12.9169 9.30867 12.9169H10.8753C11.542 12.9169 12.0837 12.3502 12.0837 11.6419C12.0837 10.8835 11.7503 10.6085 11.2587 10.4335L8.75033 9.55853C8.25866 9.38353 7.92533 9.11686 7.92533 8.35019C7.92533 7.65019 8.46699 7.0752 9.13365 7.0752H10.7003C11.467 7.0752 12.092 7.7252 12.092 8.53353"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.25V13.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3337 9.99984C18.3337 14.5998 14.6003 18.3332 10.0003 18.3332C5.40033 18.3332 1.66699 14.5998 1.66699 9.99984C1.66699 5.39984 5.40033 1.6665 10.0003 1.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 4.99984V1.6665H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.167 5.83317L18.3337 1.6665"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
